import { render, staticRenderFns } from "./CallCentreSalesData.vue?vue&type=template&id=13b8a33c&scoped=true"
import script from "./CallCentreSalesData.vue?vue&type=script&lang=ts"
export * from "./CallCentreSalesData.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreSalesData.vue?vue&type=style&index=0&id=13b8a33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8a33c",
  null
  
)

export default component.exports